import { useEffect } from 'react';
import { isNative } from '../utils/platform';

const isExternalLink = (href) => {
  if (!href) return false;
  if (href.startsWith('http://') || href.startsWith('https://')) {
    // Different origin than the app → external
    try {
      const url = new URL(href);
      return url.origin !== window.location.origin;
    } catch {
      return false;
    }
  }
  return false;
};

export function useExternalLinks() {
  useEffect(() => {
    if (!isNative()) return;
    // eslint-disable-next-line no-unused-vars
    let cancelled = false;

    const handler = async (event) => {
      const anchor = event.target.closest('a[href]');
      if (!anchor) return;
      const href = anchor.getAttribute('href');
      if (!isExternalLink(href)) return;

      event.preventDefault();
      const { Browser } = await import('@capacitor/browser').catch(() => ({}));
      if (Browser) {
        await Browser.open({ url: href });
        return;
      }
      // Fallback: use App.openUrl
      const { App } = await import('@capacitor/app');
      await App.openUrl({ url: href });
    };

    document.addEventListener('click', handler);
    return () => {
      cancelled = true;
      document.removeEventListener('click', handler);
    };
  }, []);
}
